import {validateValue} from '../helpers/validation'

// Begin action types
export const FETCH_ARTICLE_EDIT_DATA_SUCCESS = 'FETCH_ARTICLE_EDIT_DATA_SUCCESS'
export const VALIDATE_ARTICLE_EDIT_FIELD = 'VALIDATE_ARTICLE_EDIT_FIELD'
export const SUBMIT_ARTICLE_EDIT_FIELDS = 'SUBMIT_ARTICLE_EDIT_FIELDS'
export const CLEAR_ARTICLE_EDIT_FIELDS = 'CLEAR_ARTICLE_EDIT_FIELDS'
// End action types

export const fetchArticleEditDataSuccess = (data) => ({
  type: FETCH_ARTICLE_EDIT_DATA_SUCCESS,
  data
});
export const validateArticleEditField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_ARTICLE_EDIT_FIELD,
    field
  }
}
export const submitArticleEditFields = (fields) => {
  return {
    type: SUBMIT_ARTICLE_EDIT_FIELDS,
    fields
  }
}
export const clearArticleEditFields = (fields) => {
  return {
    type: CLEAR_ARTICLE_EDIT_FIELDS
  }
}